import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "layerMain" }
const _hoisted_2 = { class: "layerMainText" }
const _hoisted_3 = { class: "bold" }
const _hoisted_4 = { class: "layerBtnArea" }
const _hoisted_5 = { class: "layerMain" }
const _hoisted_6 = { class: "layerMainText" }
const _hoisted_7 = { class: "layerBtnArea" }
const _hoisted_8 = { class: "layerMain" }
const _hoisted_9 = { class: "preViewLayer" }
const _hoisted_10 = { class: "preViewCut" }
const _hoisted_11 = { class: "bold" }
const _hoisted_12 = { class: "preViewTextBox" }
const _hoisted_13 = { class: "layerBtnArea" }
const _hoisted_14 = { class: "box" }
const _hoisted_15 = { class: "searchArea right" }
const _hoisted_16 = { class: "box overflow" }
const _hoisted_17 = {
  class: "pageTitleTab left",
  style: {"width":"100%","margin-bottom":"20px"}
}
const _hoisted_18 = { class: "left dateSelectArea mgR15" }
const _hoisted_19 = { class: "left dateSelectBtn" }
const _hoisted_20 = { class: "searchArea left" }
const _hoisted_21 = {
  class: "pageTitleTab left",
  style: {"margin-right":"50px"}
}
const _hoisted_22 = {
  class: "pageTitleTab right",
  style: {"margin-right":"50px"}
}
const _hoisted_23 = { class: "box" }
const _hoisted_24 = { class: "tableList mgB15" }
const _hoisted_25 = { style: {"width":"5%"} }
const _hoisted_26 = ["value"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "blue" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { class: "conBottom" }
const _hoisted_33 = { class: "rightbtn" }
const _hoisted_34 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JSDPageCtrl = _resolveComponent("JSDPageCtrl")!
  const _directive_drt_center = _resolveDirective("drt-center")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", {
      ref: "errorLayer",
      class: "layer deletAlt",
      style: _normalizeStyle({top: $data.ui.error.top+'px'})
    }, [
      _cache[28] || (_cache[28] = _createElementVNode("div", { class: "layerTitle" }, "알림", -1)),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.arr.detail_list, (r) => {
            return (_openBlock(), _createElementBlock("div", null, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(r.UMS_ERR_CDNM), 1),
              _createTextVNode(" – " + _toDisplayString(r.CUST_NM) + "(" + _toDisplayString(r.IS_SEX == 1 ? '남':'여') + _toDisplayString(r.CUST_AGE > 0  ? '/'+r.CUST_AGE:'') + ")", 1),
              _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1)),
              _createTextVNode(" " + _toDisplayString(r.CODE_DESC), 1)
            ]))
          }), 256))
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: "grayBtn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($data.ui.error.is_view = false))
        }, "취소")
      ])
    ], 4)), [
      [_vShow, $data.ui.error.is_view],
      [_directive_drt_center, $data.ui.error.is_view]
    ]),
    _withDirectives(_createElementVNode("div", {
      ref: "detailLayer",
      class: "layer deletAlt",
      style: _normalizeStyle({top: $data.ui.detail.top+'px', left:$data.ui.detail.left+'px'})
    }, [
      _cache[30] || (_cache[30] = _createElementVNode("div", { class: "layerTitle" }, "받으신 분", -1)),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.arr.detail_list, (r) => {
            return (_openBlock(), _createElementBlock("span", null, _toDisplayString(r.CUST_NM) + "(" + _toDisplayString(r.IS_SEX == 1 ? '남':'여') + _toDisplayString(r.CUST_AGE > 0  ? '/'+r.CUST_AGE:'') + ")   ", 1))
          }), 256))
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          class: "blueBtn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.resend_recvList()))
        }, "다시선택"),
        _cache[29] || (_cache[29] = _createTextVNode("  ", -1)),
        _createElementVNode("button", {
          class: "grayBtn",
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($data.ui.detail.is_view = false))
        }, "취소")
      ])
    ], 4), [
      [_vShow, $data.ui.detail.is_view]
    ]),
    _withDirectives(_createElementVNode("div", {
      ref: "previewLayer",
      class: "layer deletAlt",
      style: _normalizeStyle({top: $data.ui.preview.top+'px', left:$data.ui.preview.left+'px'})
    }, [
      _cache[31] || (_cache[31] = _createElementVNode("div", { class: "layerTitle" }, "메시지 전체보기", -1)),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.arr.detail_list, (r) => {
            return (_openBlock(), _createElementBlock("span", null, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(r.CUST_NM) + "(" + _toDisplayString(r.IS_SEX == 1 ? '남':'여') + _toDisplayString(r.CUST_AGE > 0  ? '/'+r.CUST_AGE:'') + ")", 1),
                _createTextVNode(" " + _toDisplayString(r.RECV_HDPH_NO), 1)
              ]),
              _createElementVNode("div", _hoisted_12, _toDisplayString(r.CONT), 1)
            ]))
          }), 256))
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("button", {
          class: "grayBtn",
          onClick: _cache[3] || (_cache[3] = ($event: any) => ($data.ui.preview.is_view = false))
        }, "닫기")
      ])
    ], 4), [
      [_vShow, $data.ui.preview.is_view]
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("button", {
        class: "whiteBtn mgR10",
        onClick: _cache[4] || (_cache[4] = ($event: any) => ($options.resend_ums()))
      }, "연락처 다시선택 발송"),
      _createElementVNode("div", _hoisted_15, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "search",
          maxlength: "20",
          placeholder: "이름이나 전화번호, 내용",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($data.api.list.SEARCH_KEY) = $event)),
          onKeyup: _cache[6] || (_cache[6] = _withKeys(($event: any) => {$options.movePage(1);}, ["enter"]))
        }, null, 544), [
          [_vModelText, $data.api.list.SEARCH_KEY]
        ]),
        _createElementVNode("div", {
          class: "searchBtn",
          onClick: _cache[7] || (_cache[7] = ($event: any) => {$options.movePage(1);})
        }, "검색")
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", {
          class: _normalizeClass(["tabBtn", {select : $data.api.list.MEDIA_TYPE_CD==''}]),
          onClick: _cache[8] || (_cache[8] = ($event: any) => {$data.api.list.MEDIA_TYPE_CD='';$options.movePage(1)})
        }, "전체", 2),
        _createElementVNode("div", {
          class: _normalizeClass(["tabBtn", {select : $data.api.list.MEDIA_TYPE_CD=='1'}]),
          onClick: _cache[9] || (_cache[9] = ($event: any) => {$data.api.list.MEDIA_TYPE_CD='1';$options.movePage(1)})
        }, "SMS", 2),
        _createElementVNode("div", {
          class: _normalizeClass(["tabBtn", {select : $data.api.list.MEDIA_TYPE_CD=='3'}]),
          onClick: _cache[10] || (_cache[10] = ($event: any) => {$data.api.list.MEDIA_TYPE_CD='3';$options.movePage(1)})
        }, "MMS", 2)
      ]),
      _createElementVNode("div", null, [
        _cache[35] || (_cache[35] = _createElementVNode("div", { class: "left mgR15 bold" }, "조회기간 :", -1)),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _withDirectives(_createElementVNode("input", {
              type: "date",
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($data.api.list.STRT_DA) = $event))
            }, null, 512), [
              [_vModelText, $data.api.list.STRT_DA]
            ]),
            _cache[32] || (_cache[32] = _createTextVNode(" ~ ", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "date",
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($data.api.list.END_DA) = $event))
            }, null, 512), [
              [_vModelText, $data.api.list.END_DA]
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", {
              class: "searchBtn",
              onClick: _cache[13] || (_cache[13] = ($event: any) => {$options.movePage(1);})
            }, "검색")
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", {
            class: "tabBtn",
            onClick: _cache[14] || (_cache[14] = ($event: any) => ($options.setData('1W')))
          }, "1주일"),
          _createElementVNode("div", {
            class: "tabBtn",
            onClick: _cache[15] || (_cache[15] = ($event: any) => ($options.setData('1M')))
          }, "1개월"),
          _createElementVNode("div", {
            class: "tabBtn",
            onClick: _cache[16] || (_cache[16] = ($event: any) => ($options.setData('3M')))
          }, "3개월")
        ]),
        _withDirectives(_createElementVNode("select", {
          class: "selectBox left",
          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (($data.api.list.SMT_TYPE) = $event)),
          onChange: _cache[18] || (_cache[18] = ($event: any) => ($options.movePage(1)))
        }, [...(_cache[33] || (_cache[33] = [
          _createElementVNode("option", { value: 0 }, "발송방법 전체", -1),
          _createElementVNode("option", { value: 1 }, "폰발송", -1),
          _createElementVNode("option", { value: 2 }, "웹발송", -1)
        ]))], 544), [
          [_vModelSelect, $data.api.list.SMT_TYPE]
        ]),
        _withDirectives(_createElementVNode("select", {
          class: "selectBox left",
          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (($data.api.list.SEND_STAT_CD) = $event)),
          onChange: _cache[20] || (_cache[20] = ($event: any) => ($options.movePage(1)))
        }, [...(_cache[34] || (_cache[34] = [
          _createStaticVNode("<option value=\"\">발송결과 전체</option><option value=\"1\">발송대기</option><option value=\"2\">발송중</option><option value=\"3\">발송성공</option><option value=\"4\">발송실패</option>", 5)
        ]))], 544), [
          [_vModelSelect, $data.api.list.SEND_STAT_CD]
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", {
            class: "tabBtn",
            onClick: _cache[21] || (_cache[21] = ($event: any) => ($options.error_delete()))
          }, "오류 연락처 삭제")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("table", _hoisted_24, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_25, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (($data.ui.is_check_all) = $event)),
              onChange: _cache[23] || (_cache[23] = ($event: any) => ($options.check_all()))
            }, null, 544), [
              [_vModelCheckbox, $data.ui.is_check_all]
            ])
          ]),
          _cache[36] || (_cache[36] = _createElementVNode("th", null, "발송일", -1)),
          _cache[37] || (_cache[37] = _createElementVNode("th", null, "받는사람", -1)),
          _cache[38] || (_cache[38] = _createElementVNode("th", { style: {"width":"40%"} }, "내용", -1)),
          _cache[39] || (_cache[39] = _createElementVNode("th", null, "구분", -1)),
          _cache[40] || (_cache[40] = _createElementVNode("th", null, "상태", -1))
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.arr.send_list, (r) => {
          return (_openBlock(), _createElementBlock("tr", null, [
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (($data.ui.check_list) = $event)),
                value: r.SEQ_NO
              }, null, 8, _hoisted_26), [
                [_vModelCheckbox, $data.ui.check_list]
              ]),
              _cache[41] || (_cache[41] = _createTextVNode()),
              _cache[42] || (_cache[42] = _createElementVNode("br", null, null, -1)),
              _createTextVNode(" " + _toDisplayString(r.SEQ_NO), 1)
            ]),
            _createElementVNode("td", null, [
              _createTextVNode(_toDisplayString(r.FMT_SEND_DA), 1),
              _cache[43] || (_cache[43] = _createElementVNode("br", null, null, -1)),
              _createTextVNode(_toDisplayString(r.SEND_TM), 1)
            ]),
            _createElementVNode("td", {
              onClick: ($event: any) => ($options.detail_view($event, r)),
              style: {"cursor":"pointer"}
            }, _toDisplayString(r.CUST_NM) + "(" + _toDisplayString(r.IS_SEX == 1 ? '남':'여') + _toDisplayString(r.CUST_AGE > 0  ? '/'+r.CUST_AGE:'') + ") " + _toDisplayString(r.CNT > 1 ? ' 외'+ (r.CNT - 1) + '건' : ''), 9, _hoisted_27),
            _createElementVNode("td", {
              onClick: ($event: any) => ($options.preview_view($event, r)),
              style: {"cursor":"pointer"}
            }, _toDisplayString(r.CONT), 9, _hoisted_28),
            _createElementVNode("td", null, _toDisplayString(r.UMS_TYPE_CDNM) + " / " + _toDisplayString(r.MEDIA_TYPE_CDNM) + " / " + _toDisplayString(r.IS_SMT == 1 ? '폰발송':'웹발송'), 1),
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("div", null, [
                _createElementVNode("span", _hoisted_29, _toDisplayString(r.SEND_STAT_CDNM), 1)
              ], 512), [
                [_vShow, r.SEND_STAT_CD=='1' || r.SEND_STAT_CD=='2']
              ]),
              _withDirectives(_createElementVNode("div", null, [
                _createElementVNode("span", null, _toDisplayString(r.SEND_STAT_CDNM), 1)
              ], 512), [
                [_vShow, r.SEND_STAT_CD=='3']
              ]),
              _withDirectives(_createElementVNode("div", null, [
                _cache[44] || (_cache[44] = _createElementVNode("span", { class: "red" }, "발송실패", -1)),
                _cache[45] || (_cache[45] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("button", {
                  class: "grayBtn",
                  onClick: ($event: any) => ($options.error_view($event, r))
                }, "실패사유", 8, _hoisted_30)
              ], 512), [
                [_vShow, r.SEND_STAT_CD=='4']
              ])
            ])
          ]))
        }), 256)),
        ($data.arr.send_list.length == 0)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_31, [...(_cache[46] || (_cache[46] = [
              _createElementVNode("td", { colspan: "6" }, " 검색결과가 없습니다.", -1)
            ]))]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createVNode(_component_JSDPageCtrl, {
          ref: "pageCtrl",
          page: $data.page,
          cntPage: $data.api.list.CNT_PAGE,
          maxCnt: $data.page.maxCnt,
          onPageMove: $options.movePage
        }, null, 8, ["page", "cntPage", "maxCnt", "onPageMove"]),
        _createElementVNode("div", _hoisted_33, [
          _withDirectives(_createElementVNode("select", {
            class: "selectBox left",
            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (($data.api.list.CNT_PAGE) = $event)),
            onChange: _cache[26] || (_cache[26] = ($event: any) => ($options.movePage(1)))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.api.page_cnt, (n) => {
              return (_openBlock(), _createElementBlock("option", { value: n }, _toDisplayString(`${n}줄 보기`), 9, _hoisted_34))
            }), 256))
          ], 544), [
            [_vModelSelect, $data.api.list.CNT_PAGE]
          ])
        ])
      ])
    ]),
    _cache[47] || (_cache[47] = _createStaticVNode("<div class=\"layer msgsendBox box overflow left\" style=\"display:none;\"><div class=\"msgListTitle\"> 문자발송 </div><div class=\"msgBoxLeft mgR15\"><div class=\"msgTextarea mgB10\" style=\"\" contenteditable=\"true\" placeholder=\"메시지를 입력해주세요\"><div>제목 : <input type=\"text\" class=\"selectCutNumInput\" placeholder=\"제목을 입력하세요\"></div><img src=\"images/imgsample.jpg\"><br> “성공을 위해선, 불가능한 것을 시도하라!” <button class=\"hoching\">호칭 x </button>늘 도전하는 힘찬 하루 되세요~ </div><div class=\"poRel mgB10\"><button class=\"grayBtn\">호칭</button><button class=\"grayBtn\">첨부</button><button class=\"grayBtn\"> 특수문자 </button><div class=\"layer emoticonLayer\" style=\"display:none;\"><table class=\"emoTable1\" style=\"display:table;\"><colgroup><col width=\"30\"><col width=\"30\"><col width=\"30\"><col width=\"30\"><col width=\"30\"><col width=\"30\"></colgroup><tbody><tr><td>♥</td><td>♡</td><td>★</td><td>☆</td><td>▶</td><td>▷</td></tr><tr><td>●</td><td>■</td><td>▲</td><td>▒</td><td>♨</td><td>™</td></tr><tr><td>℡</td><td>♬</td><td>♪</td><td>☞</td><td>♂</td><td>♀</td></tr><tr><td>◆</td><td>◇</td><td>♣</td><td>♧</td><td>☎</td><td>◀</td></tr><tr><td>◁</td><td>○</td><td>□</td><td>▼</td><td>∑</td><td>㉿</td></tr><tr><td>◈</td><td>▣</td><td>『</td><td>』</td><td>☜</td><td>♬</td></tr></tbody></table><table class=\"emoTable2\" style=\"display:none;\"><colgroup><col width=\"57\"><col width=\"57\"><col width=\"57\"></colgroup><tbody><tr><td> (^.^)V</td><td> (n . n)</td><td>(/*.*)/</td></tr><tr><td>(0^.^0)</td><td>(*^o^*)</td><td>づ^0^)づ</td></tr><tr><td>☆(~.^)/</td><td>♡.♡</td><td>o(^^o) </td></tr><tr><td>(*^^ㆀ)</td><td>(*^.^)♂</td><td> (^ㅇ^)♬</td></tr><tr><td>(⌒ε⌒*)</td><td>(*..)(..*)</td><td>l -,.- l</td></tr><tr><td>(@_@)</td><td>ご,.ご</td><td>o(&gt;_&lt;)o</td></tr></tbody></table><table class=\"emoTable3\" style=\"display:none;\"><colgroup><col width=\"57\"><col width=\"57\"><col width=\"57\"></colgroup><tbody><tr><td>=◑.◐=</td><td>(ら-o-)っ</td><td>S￣ヘ￣S</td></tr><tr><td>(Θ_Θ)</td><td>(★.★)</td><td>(づ_ど)</td></tr><tr><td>&amp;(_._)&amp;</td><td>q⊙.⊙p</td><td>@(*)(*)@</td></tr><tr><td> </td><td> </td><td> </td></tr><tr><td> </td><td> </td><td> </td></tr><tr><td> </td><td> </td><td> </td></tr></tbody></table><table class=\"pagingCtrl\" style=\"left:33%;width:85px;display:block;\"><tbody><tr><td width=\"20%\">◀</td><td width=\"20%\" style=\"cursor:pointer;\" class=\"pagingSelect\">1</td><td width=\"20%\" style=\"cursor:pointer;\">2</td><td width=\"20%\" style=\"cursor:pointer;\">3</td><td width=\"20%\" style=\"cursor:pointer;\">▶</td></tr></tbody></table></div><div class=\"layer addimg\" style=\"display:none;\"><div class=\"layerTitle\">이미지 첨부</div><div class=\"mgB15\">이미지는 <b>한 번에 최대 3개까지<br>첨부</b>할 수 있습니다.</div><div><input type=\"file\" class=\"addimgFile\" placeholder=\"클릭하여 첨부할 이미지를 선택하세요\"><input type=\"file\" class=\"addimgFile\" placeholder=\"클릭하여 첨부할 이미지를 선택하세요\"><input type=\"file\" class=\"addimgFile\" placeholder=\"클릭하여 첨부할 이미지를 선택하세요\"></div><div class=\"grayBox mgB15\"> 파일은 JPG 이미지 파일만 첨부할 수 있습니다. 이미지가 (1500 픽셀 X1500픽셀)을 초과하는 경우, 비율에 맞게 자동 축소되며 압축으로 인한 품질의 저하가 있을 수 있습니다. </div><div class=\"textCenter\"><button class=\"grayBtn\">취소</button><button class=\"blueBtn\">확인</button></div></div></div><div class=\"overflow mgB10\" style=\"width:100%;\"><div class=\"right bold\" style=\"font-size:20px;\"><span class=\"blue\">SMS</span> 0/88 Byte</div></div><div class=\"sendNumBox\"><div class=\"selectBox left\">발신번호</div><select class=\"selectBox left\"><option>010-8888-8888</option><option>010-9999-9999</option></select></div></div><div class=\"msgBoxLeft\" style=\"\"><div class=\"selectCutBox mgB15\"><div><input type=\"text\" class=\"selectCutNumInput\" placeholder=\"받는사람\"> <button class=\"whiteBtn right\">그룹선택</button></div><div class=\"cutBlock\">김철수 010-0000-0000 <button class=\"closeBtn right\">X</button></div><div class=\"cutBlock\">김철수 010-0000-0000 <button class=\"closeBtn right\">X</button></div><div class=\"cutBlock\">김철수 010-0000-0000 <button class=\"closeBtn right\">X</button></div><div class=\"cutBlock\">김철수 010-0000-0000 <button class=\"closeBtn right\">X</button></div><div class=\"layer cutSelectBlock\" style=\"display:none;\"><ul><li>김철수 010-1118-1111</li><li>김다철 010-2222-2222</li><li>김철라라라 010-3333-3333</li><li>김철마 010-4444-4444</li><li>김철마 010-4444-4444</li><li>김철마 010-4444-4444</li><li>김철마 010-4444-4444</li><li>김철마 010-4444-4444</li><li>김철마 010-4444-4444</li><li>김철마 010-4444-4444</li></ul></div></div><div class=\"pageTitleTab mgB15\" style=\"width:100%;\"><div class=\"tabBtn select\">폰발송</div><div class=\"tabBtn\">코인발송</div></div><div class=\"mgB15\"><p class=\"selectBox bold\">폰발송 가능 건수 : <span class=\"blue\">352</span></p><p> ※ 사용자님의 스마트폰에서 직접 발송한 건은 ‘폰발송 가능 건수’에 포함되지 않습니다. </p></div><div class=\"textCenter\"><button class=\"greenBtn mgR10\">미리보기</button><button class=\"grayBtn mgR10\">예약발송</button><button class=\"blueBtn\">즉시발송</button></div></div></div>", 1))
  ], 64))
}